interface FilterBarProps {
  categories: { id: string; label: string }[];
  active: string;
  onChange: (id: string) => void;
}

export function FilterBar({ categories, active, onChange }: FilterBarProps) {
  return (
    <div className="filter-bar">
      {categories.map((cat) => (
        <button
          key={cat.id}
          type="button"
          className={`filter-btn ${active === cat.id ? 'active' : ''}`}
          onClick={() => onChange(cat.id)}
        >
          {cat.label}
        </button>
      ))}
    </div>
  );
}
